import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { saveSettings } from "../reducers/settings/settingsReducer";

export default function useSettingsDispatchers() {
  const dispatch = useDispatch();

  return useMemo(
    () => ({
      handleSettings: (value) => dispatch(saveSettings(value)),
    }),
    [dispatch]
  );
}
